import { PageHeader } from '@/components/layout/PageHeader';
import { Button } from '@/components/ui/button';
import { FlexCol, FlexRow } from '@/components/ui/flex';
import {
  useCreateTableViewService,
  useTableViewsService,
} from '@/services/tableViews';
import { SearchBar } from '@/shared/SearchBar';
import { Grid2X2, Plus } from 'lucide-react';
import { useState, type FC } from 'react';
import { useNavigate } from 'react-router-dom';
import { EmptyState } from './components/EmptyState';
import { TableViewsTable } from './components/TableViewsTable';

export const TableViewsPage: FC = () => {
  const navigate = useNavigate();
  const { tableViews, isPending } = useTableViewsService();
  const { createTableView, isCreating } = useCreateTableViewService();
  const [searchString, setSearchString] = useState('');

  const handleCreateTableView = () => {
    createTableView(
      { name: 'New Table View' },
      {
        onSuccess: data => {
          navigate(data.id, { state: { openTemplateDialog: true } });
        },
      }
    );
  };

  const isEmpty = tableViews.length === 0;

  return (
    <FlexCol p="6" w="full" gap="6" className="max-w-[1600px]">
      <FlexRow alignItems="center" justifyContent="between" w="full">
        <PageHeader
          title="Table Views"
          subtitle="Systematic information extraction from files"
        >
          <Grid2X2 size={22} />
        </PageHeader>
        {!isEmpty && (
          <Button onClick={handleCreateTableView} disabled={isCreating}>
            <Plus />
            Create Table View
          </Button>
        )}
      </FlexRow>

      {isEmpty && !isPending ? (
        <FlexCol
          alignItems="center"
          justifyContent="center"
          gap="4"
          className="flex-1 py-16"
        >
          <EmptyState
            onCreateTableView={handleCreateTableView}
            isCreating={isCreating}
          />
        </FlexCol>
      ) : (
        <>
          <SearchBar
            searchString={searchString}
            setSearchString={setSearchString}
            placeholder="Search table views..."
            className="w-[300px]"
          />
          <TableViewsTable searchString={searchString} />
        </>
      )}
    </FlexCol>
  );
};
